import React from 'react'
import { Table as AntTable } from 'antd'
import { TableProps as AntTableProps } from 'antd/lib/table'

// using same typescript definition as antd
export function Table<RecordType extends object = any>({
  rowKey,
  dataSource,
  className,
  columns,
  onChange,
  loading,
  tableLayout,
  onRow,
  pagination,
  rowSelection,
  bordered,
  rowClassName,
  expandable,
  expandRowByClick = false,
  showHeader = true,
  title,
  scroll,
  size,
  sticky,
  footer,
  // TODO: rest operator should be replaced with individual props
  ...rest
}: AntTableProps<RecordType>): React.ReactElement {
  return (
    <AntTable<RecordType>
      className={className}
      rowKey={rowKey}
      rowSelection={rowSelection}
      dataSource={dataSource}
      columns={columns}
      onChange={onChange}
      loading={loading}
      tableLayout={tableLayout}
      pagination={pagination}
      onRow={onRow}
      bordered={bordered}
      rowClassName={rowClassName}
      expandable={expandable}
      expandRowByClick={expandRowByClick}
      showHeader={showHeader}
      title={title}
      scroll={scroll}
      size={size}
      sticky={sticky}
      footer={footer}
      {...rest}
    />
  )
}
